import { forwardRef, ReactElement, Ref } from "react";
import { EditGenericWithDestinationWindowTile, EditGenericWithDestinationWindowTilePropsBase } from "./EditGenericWithDestinationWindowTile";
import { EditTileHandle } from "./EditTile";
import { ConnectWiseDetailsTileModel, updateConnectWiseTile } from "client/Api/Workspace/workspace";

export type EditConnectWiseTileProps = EditGenericWithDestinationWindowTilePropsBase<ConnectWiseDetailsTileModel>;

export const EditConnectWiseTile = forwardRef(
	(props: EditConnectWiseTileProps, ref: Ref<EditTileHandle>): ReactElement => {

		return (
			<EditGenericWithDestinationWindowTile
				{...props}
				requestHandler={updateConnectWiseTile}
				ref={ref}
			/>
		);
	}
);
EditConnectWiseTile.displayName = "EditConnectWiseTile";
